import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { AGENCIES } from '~/queries/keys';

export interface Agency {
  id: string;
  name: string;
  slug: string;
  dataDogName: string;
  agencyLogo: string;
  totalManagers: number;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
  shareToken: string;
  sharedWith?: null[] | null;
  accessList?: null[] | null;
  sharedViews: number;
  enabledControls?: null[] | null;
  createdAtAgo: string;
  updatedAtAgo: string;
  isPasswordProtected: boolean;
  theming?: {
    primaryColor?: string;
    secondaryColor?: string;
    backgroundColor?: string;
    font?: string;
  };
}

export const useGetAgency = (idOrSlug: string) => {
  return useQuery<Agency>({
    queryKey: [AGENCIES, { idOrSlug }],
    queryFn: () => axios.get(`/api/agencies/${idOrSlug}`).then((r) => r.data),
    enabled: Boolean(idOrSlug),
    retry: false,
    staleTime: 5 * 1000 * 60,
  });
};
